module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/muscle-d8f4f33dc43813bef556f9ee1211fe5b.png";